<template>
  <v-page-content>
    <div class="mx-auto" v-if="isInitialized">
      <div class="d-flex">
        <tools-selector
          :panel="panel"
          class="flex-grow-1"
          v-model="selectedTool"
        />
        <div class="panelDiv__panel ml-2 px-2 align-self-end">
          <b-button
            class="my-2 mr-2 panelDiv__panel-buttons"
            v-if="isCreatingSteps"
            :disabled="!selectedStage.steps.length"
            @click="saveFirstVersionStage"
            variant="primary"
            >Сохранить</b-button
          >
          <b-button
            class="my-2 mr-2 panelDiv__panel-buttons"
            v-if="isCreatingSteps"
            :disabled="!selectedStage.steps.length"
            @click="onDropClick"
            variant="primary"
            >Сбросить</b-button
          >
          <b-button
            class="my-2 mr-2 panelDiv__panel-buttons"
            :disabled="trainingMode ? true : false"
            @click="showHint"
            variant="primary"
            >Подсказка</b-button
          >
          <b-button
            class="my-2 mr-2 panelDiv__panel-buttons"
            :disabled="trainingMode ? true : false"
            @click="showInstruction"
            variant="primary"
            >Инструкция</b-button
          >
        </div>
      </div>
      <div v-if="panels.length && (selectedPanel || selectedPanel === 0)">
        <div class="panelDiv__label mt-2">
          <div class="d-flex align-items-center">
            <h5>
              <b-badge variant="primary">
                Пульт: {{ panels[selectedPanel].name }}
              </b-badge>
            </h5>
            <h5 v-if="isCreatingSteps">
              <b-badge class="ml-2" variant="primary">Режим записи</b-badge>
              <b-badge class="ml-2" variant="primary">
                Роль: {{ roleOnPanel }}</b-badge
              >
            </h5>
            <div class="ml-auto mb-2">
              <b-button
                variant="primary"
                @click="goPanelBefore"
                class="mr-2 panelDiv__label-buttons"
                ><em class="fas fa-arrow-left"></em
              ></b-button>
              <b-button
                variant="primary"
                @click="goPanelAfter"
                class="panelDiv__label-buttons"
                ><em class="fas fa-arrow-right"></em
              ></b-button>
            </div>
          </div>
        </div>
        <b-row>
          <b-col sm="12" class="text-center">
            <training-panel
              @actionDone="onActionDone"
              ref="panel"
              @showHint="showHint"
              @showInstruction="showInstruction"
              :panel-id="panels[selectedPanel].id"
            ></training-panel>
          </b-col>
        </b-row>
      </div>
    </div>
    <div v-if="isInitialized">
      <b-modal id="instructionModal" size="xl" hide-footer centered>
        <template slot="modal-title">
          <div>
            Инструкция
          </div>
        </template>
        <div>
          <ag-grid-vue
            style="height: 350px"
            class="ag-theme-material ag-grid-for-instruction-training"
            :columnDefs="columnDefs"
            :gridOptions="gridOptions"
            :rowData="rowData"
            @grid-ready="onGridReady"
            @gridSizeChanged="onGridSizeChanged"
            @rowDataChanged="onRowDataChanged"
            @column-resized="onColumnResized"
          >
          </ag-grid-vue>
        </div>
        <b-row class="mt-4">
          <b-col> </b-col>
          <b-col>
            <b-button
              block
              variant="primary"
              @click="$bvModal.hide('instructionModal')"
            >
              Ок
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
      <stage-finish-modal
        :mistakes="mistakes"
        :count-mistakes="countMistakes"
        :mark="mark"
      ></stage-finish-modal>
      <drop-first-version-stage-modal
        @acceptDrop="dropFirstVersion"
        :stage-name="selectedStage.name"
      ></drop-first-version-stage-modal>
    </div>
  </v-page-content>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { AgGridVue } from 'ag-grid-vue'
import { forEachAsync } from 'foreachasync'
import { Mutex } from 'async-mutex'
import TrainingPanel from '@/components/content/education/training/TrainingPanel.vue'
import ToolsSelector from '@/components/content/education/training/tools/ToolsSelector.vue'
import StageFinishModal from '@/components/content/education/training/modals/StageFinishModal.vue'
import DropFirstVersionStageModal from '@/components/content/education/training/modals/DropFirstVersionStageModal.vue'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'
import StepInstructionRenderer from '@/components/helpers/renderers/training/StepInstructionRenderer'

/* eslint-disable no-plusplus */
/* eslint-disable no-use-before-define */
/* eslint-disable func-names */

export default {
  name: 'TrainingStep',
  components: {
    AgGridVue,
    TrainingPanel,
    ToolsSelector,
    StageFinishModal,
    DropFirstVersionStageModal
  },
  data() {
    return {
      defaultImage: '/images/w1400_1.jpg',
      selectedTool: null,
      countMistakes: 0,
      mistakes: [],
      mark: 0,
      rowData: null,
      context: {
        componentParent: this
      },
      columnDefs: [],
      gridApi: null,
      gridOptions: {
        defaultColDef: {
          autoHeight: true
        },
        localeText: AG_GRID_LOCALE_RU,
        components: {
          StepInstructionRenderer
        },
        headerHeight: 40,
        enableCellTextSelection: true,
        suppressMenuHide: true
      },
      instruction: null,
      paramsObject: {
        isAutoPlay: true,
        tool: null
      },
      rolesForAutoPlay: [],
      panelsBeforeChanging: [],
      codeBeforeChanges: [],
      actionDoneMutex: new Mutex(),
      checkMutex: new Mutex()
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.setCurrentStep(0)
    this.setSelectedPanel(0)
    this.setIsFirstCreatingTrainingStage(0)
    next()
  },
  beforeDestroy() {
    this.setCurrentStep(0)
    this.setSelectedPanel(0)
    this.setIsFirstCreatingTrainingStage(0)
  },
  async mounted() {
    if (
      (!this.selectedRole || !this.selectedStage)
      && this.$route.path.includes('education')
    ) {
      // this.$router.push('..')
    }
    if (!this.isInitialized) {
      this.onClose()
      return
    }
    [this.selectedTool] = this.panel.tools
    const roles = []
    if (this.selectedStage) {
      this.selectedStage.rolesOnPanel.forEach((r) => {
        if (!roles.includes(r.role)) {
          roles.push(r.role)
        }
      })
    }
    const instructionTable = []
    roles.forEach((role) => {
      this.selectedStage.steps
        .filter((p) => p.role === role)
        .forEach((step, index) => {
          const tableCell = instructionTable.find((p) => p.step === index + 1)
          if (tableCell) {
            tableCell[role] = {}
            tableCell[role].message = step.description
          } else {
            const tableData = {}
            tableData.step = index + 1
            tableData[role] = {}
            tableData[role].isPassed = false
            tableData[role].message = step.description
            instructionTable.push(tableData)
          }
        })
    })
    const columns = []
    columns.push({
      headerName: 'Шаг',
      field: 'step',
      lockPosition: true,
      suppressSizeToFit: true,
      headerClass: 'instruction-table-header',
      width: 90
    })
    for (let i = 0; i < roles.length; i++) {
      columns.push({
        headerName: roles[i],
        lockPosition: true,
        field: roles[i],
        cellRenderer: 'StepInstructionRenderer',
        headerClass: 'instruction-table-header',
        width: 170,
        minWidth: 170
      })
    }
    this.columnDefs = columns
    this.rowData = instructionTable
    this.instruction = instructionTable

    roles.forEach((role) => {
      if (this.$route.path.includes('group')) {
        if (!this.rolesForGroup.includes(role)) {
          this.rolesForAutoPlay.push(role)
        }
      } else if (this.selectedRole !== role) {
        this.rolesForAutoPlay.push(role)
      }
    })
    if (this.selectedStage && this.selectedStage.stageName) {
      const defaultStage = this.course.stages.find(
        (st) => st.name === this.selectedStage.stageName,
      )
      this.paramsObject.isAutoPlay = true
      // defaultStage.steps.forEach((step) => {
      const release = await this.checkMutex.acquire()
      try {
        await forEachAsync(defaultStage.steps, async (step) => {
          if (step.number < this.selectedStage.startStep) {
            await this.course.module[step.action.autoFunction](
              this.getApi(step.action.itemId),
              this.paramsObject,
            )
            this.course.module[step.action.function](
              this.getApi(step.action.itemId),
              this.paramsObject,
            )
            this.$refs.panel.drawAll()
          }
        })
      } finally {
        release()
      }
    }
    this.$refs.panel.drawAll()
    if (this.isCreatingSteps) {
      this.codeBeforeChanges = this.course.code.slice()
      this.panels.forEach((panel) => {
        this.panelsBeforeChanging.push(panel.save())
      })
    }
    if (this.steps && this.steps.length && this.steps[0].number
      !== this.selectedStage.steps[0].number) {
      const api = this.getApi(this.steps[0].action.itemId)
      await this.checkStepForOtherRoles(api, 0)
      this.$refs.panel.initPanel()
    }
  },
  computed: {
    ...mapGetters({
      course: 'training/getTrainingCourse',
      currentStep: 'training/getCurrentStep',
      elements: 'training/getElements',
      groupStepChanged: 'training/getStepNumberForGroupTraining',
      hasRole: 'currentUser/hasRole',
      isCreatingSteps: 'training/getIsFirstCreatingTrainingStage',
      isInitialized: 'training/getIsTrainingInitialized',
      getPanels: 'training/getPanels',
      rolesForGroup: 'training/getTrainingAllRoles',
      selectedPanel: 'training/getSelectedPanel',
      selectedRole: 'training/getTrainingRole',
      selectedStage: 'training/getTrainingStep',
      trainingId: 'training/getTrainingId',
      trainingMode: 'training/getTrainingMode',
      trainingRole: 'training/getTrainingRole',
      trainingSettings: 'training/getTrainingSettings'
    }),
    roleOnPanel() {
      const { rolesOnPanel } = this.selectedStage
      const roleOnPanel = rolesOnPanel.find((r) => r.panel === this.panel.id)
      return roleOnPanel.role
    },
    steps() {
      let steps = null
      if (this.selectedStage) {
        steps = this.selectedStage.steps.filter(
          (s) => s.role === this.selectedRole,
        )
      }
      return steps
    },
    panel() {
      return this.panels[this.selectedPanel]
    },
    panels() {
      const ids = this.course.getPanelsForStage(this.selectedStage)
      return this.getPanels.filter((panel) => ids.has(panel.id))
    },
    canvasClasses() {
      return {
        'panelDiv__panel-canvas': true
      }
    }
  },
  watch: {
    selectedTool(tool) {
      this.paramsObject.tool = this.selectedTool.name
      this.$refs.panel.setTool(tool)
    },
    selectedPanel() {
      if (this.panel && this.panel.tools[0]) {
        [this.selectedTool] = this.panel.tools
      }
    },
    async groupStepChanged(value) {
      const release = await this.checkMutex.acquire()
      try {
        await this.onGroupStepChanged(value)
      } finally {
        release()
      }
    }
  },
  methods: {
    ...mapActions({
      fetchTrainingContent: 'training/fetchTrainingContent',
      pushToasts: 'toasts/pushToasts',
      sendMessage: 'socket/sendMessage',
      updateTrainingContent: 'training/updateTrainingContent'
    }),
    ...mapMutations({
      setCurrentStep: 'training/setCurrentStep',
      setIsFirstCreatingTrainingStage:
        'training/setIsFirstCreatingTrainingStage',
      setSelectedPanel: 'training/setSelectedPanel'
    }),
    async onGroupStepChanged(value) {
      if (this.$route.path.includes('group')) {
        const step = this.selectedStage.steps.find((s) => s.number === value)
        this.paramsObject.isAutoPlay = true
        await this.course.module[step.action.autoFunction](
          this.getApi(step.itemId),
          this.paramsObject,
        )
        const result = this.course.module[step.action.function](
          this.getApi(step.itemId),
          this.paramsObject,
        )
        if (result.isCorrect) {
          const stepIndex = this.selectedStage.steps
            .filter((s) => s.role === step.role)
            .findIndex((s) => s.number === step.number)
          this.instruction[stepIndex][step.role].isPassed = true
          this.$refs.panel.drawAll()
          await this.checkStepForOtherRolesAsync(this.getApi(step.action.itemId), value)
        }
      }
    },
    async onActionDone(item, element, zone, api) {
      if (this.checkMutex.isLocked()) {
        this.addMistake(api, 'Действие выполняется')
        return
      }
      const release = await this.actionDoneMutex.acquire()
      try {
        await this.actionDone(item, element, zone, api)
      } finally {
        release()
      }
    },
    setTool(tool) {
      this.$refs.panel.setTool(tool)
    },
    getApi(itemId) {
      return this.$refs.panel.getActionApi(this.panel.itemsById[itemId])
    },
    async saveFirstVersionStage() {
      this.panels.forEach((panel, index) => {
        panel.restore(this.panelsBeforeChanging[index])
      })
      await this.updateTrainingContent()
      this.pushToasts({
        title: 'Уведомление',
        message: 'Изменение завершено.',
        time: 4
      })
      this.$router.push('..')
    },
    onDropClick() {
      this.$bvModal.show('dropFirstVersionModal')
    },
    dropFirstVersion() {
      this.course.code = this.codeBeforeChanges.slice()
      this.selectedStage.steps = []
      this.panels.forEach((panel, index) => {
        panel.restore(this.panelsBeforeChanging[index])
      })
      this.panelsBeforeChanging = []
      this.panels.forEach((panel) => {
        this.panelsBeforeChanging.push(panel.save())
      })
      this.$refs.panel.initPanel()
    },
    async checkStepForOtherRoles(api, stepNumber) {
      const release = await this.checkMutex.acquire()
      try {
        await this.checkStepForOtherRolesAsync(api, stepNumber)
      } finally {
        release()
      }
    },
    async checkStepForOtherRolesAsync(api, stepNumber) {
      const step = this.selectedStage.steps.find(
        (s) => s.number === stepNumber + 1,
      )
      if (step.role !== this.selectedRole) {
        this.paramsObject.isAutoPlay = this.rolesForAutoPlay.includes(step.role)
        if (this.paramsObject.isAutoPlay) {
          await this.course.module[step.action.autoFunction](
            api,
            this.paramsObject,
          )
        }
        const result = this.course.module[step.action.function](
          api,
          this.paramsObject,
        )
        if (result.isCorrect) {
          const stepIndex = this.selectedStage.steps
            .filter((s) => s.role === step.role)
            .findIndex((s) => s.number === step.number)
          this.instruction[stepIndex][step.role].isPassed = true
          this.$refs.panel.drawAll()
          await this.checkStepForOtherRolesAsync(api, stepNumber + 1)
        }
      }
    },
    checkStepBefore(step) {
      if (step.number === this.selectedStage.steps[0].number) {
        return true
      }
      let isPreviousDone = true
      step.previous.forEach((number) => {
        const roleBefore = this.selectedStage.steps.find((st) => st.number === number).role
        const stepsForRole = this.selectedStage.steps.filter((st) => st.role === roleBefore)
        const indexStepBefore = stepsForRole.findIndex((st) => st.number === number)
        if (!this.instruction[indexStepBefore][roleBefore].isPassed) {
          isPreviousDone = false
        }
      })
      return isPreviousDone
    },
    async actionDone(item, element, zone, api) {
      if (this.isCreatingSteps) {
        this.addStep(item, element, zone, api)
      } else {
        const step = this.steps[this.currentStep]
        this.paramsObject.isAutoPlay = false
        if (!this.checkStepBefore(step)) {
          this.addMistake(api, 'Слишком рано. Ваш коллега не завершил предыдущие шаги.')
        } else if (
          this.selectedRole === step.role
          && step.action.itemId === item.id
          && step.action.panelId === api.panel.id
        ) {
          const result = this.course.module[step.action.function](
            api,
            this.paramsObject,
          )
          if (result.isCorrect) {
            this.$refs.panel.drawAll()
            this.instruction[this.currentStep][this.selectedRole].isPassed = true
            if (this.$route.path.includes('group')) {
              this.sendMessage({
                action: 'trainingStepUpdate',
                data: {
                  stepNumber: this.steps[this.currentStep].number,
                  trainingId: this.trainingId
                }
              })
            }
            this.setCurrentStep(this.currentStep + 1)
            if (this.currentStep === this.steps.length) {
              this.showResults()
            } else {
              await this.checkStepForOtherRoles(
                api,
                this.steps[this.currentStep - 1].number,
              )
            }
          } else {
            this.addMistake(api, result.message)
          }
        } else {
          this.addMistake(api, 'Неправильное действие.')
        }
      }
    },
    addStep(item, element, zone, api) {
      const statesBefore = api.panel.statesBefore[0].itemsById[item.id].displayFunctionValues
      const stepsLength = this.selectedStage.steps.length
      const newStep = {
        id: stepsLength + 1,
        role: this.roleOnPanel,
        number: stepsLength + 1,
        previous: [],
        action: {
          itemId: item.id,
          panelId: api.panel.id,
          function: `stage_${this.$route.params.stageIndex}_step_${stepsLength
            + 1}`,
          activeZoneId: zone.id,
          autoFunction: `auto_stage_${
            this.$route.params.stageIndex
          }_step_${stepsLength + 1}`
        },
        description: 'Описание действия'
      }
      const newFunctionsString = `auto_stage_${
        this.$route.params.stageIndex
      }_step_${stepsLength + 1}, stage_${
        this.$route.params.stageIndex
      }_step_${stepsLength + 1}`
      const autoFunction = []
      const actionFunction = []
      autoFunction.push('// Функция сгенерирована автоматически')
      autoFunction.push(
        `function auto_stage_${
          this.$route.params.stageIndex
        }_step_${stepsLength + 1}(api, paramsObject = {}) {`,
      )
      actionFunction.push('// Функция сгенерирована автоматически')
      actionFunction.push(
        `function stage_${this.$route.params.stageIndex}_step_${stepsLength
          + 1}(api, paramsObject = {}) {`,
      )
      actionFunction.push(
        `    if (!api.defaults.funcs.checkCurrentInstrument(paramsObject,"${
          this.selectedTool.name
        }")) {`,
      )
      actionFunction.push('        return {')
      actionFunction.push('            isCorrect: false,')
      actionFunction.push(
        '            message: api.defaults.msg.wrongTool()',
      )
      actionFunction.push('        }')
      actionFunction.push('    }')
      /* eslint-disable-next-line no-restricted-syntax */
      for (const state of Object.keys(item.displayFunctionValues)) {
        if (item.displayFunctionValues[state] !== statesBefore[state]) {
          let newValueOfState = null
          if (typeof item.displayFunctionValues[state] === 'object') {
            if (!Array.isArray(item.displayFunctionValues[state])) {
              newValueOfState = '{'
              /* eslint-disable-next-line no-restricted-syntax */
              for (const key of Object.keys(
                item.displayFunctionValues[state],
              )) {
                newValueOfState += `${key}: "${
                  item.displayFunctionValues[state][key]
                }",`
              }
              newValueOfState[newValueOfState.length - 1] = '}'
            }
          } else {
            newValueOfState = item.displayFunctionValues[state]
          }
          if (newValueOfState) {
            actionFunction.push(
              `    if (!api.defaults.funcs.checkStatusOfItem(api, ${
                api.panel.id
              }, ${item.id}, "${state}", ${newValueOfState})) {`,
            )
            actionFunction.push('        return {')
            actionFunction.push('            isCorrect: false,')
            actionFunction.push(
              '            message: api.defaults.msg.wrongState()',
            )
            actionFunction.push('        }')
            actionFunction.push('    }')
            autoFunction.push(
              `    api.defaults.funcs.updateStateOfItem(api, ${api.panel.id}, ${
                item.id
              }, "${state}", ${newValueOfState})`,
            )
          }
        }
      }
      autoFunction.push('}')
      actionFunction.push('    return {')
      actionFunction.push('        isCorrect: true,')
      actionFunction.push('        message: ""')
      actionFunction.push('    }')
      actionFunction.push('}')
      this.selectedStage.steps.push(newStep)
      let isExistExport = false
      let indexBeforePush = 0
      for (let i = this.course.code.length - 1; i >= 0; i--) {
        if (this.course.code[i].includes('module.exports')) {
          indexBeforePush = i
          i = 0
          isExistExport = true
        }
      }
      if (isExistExport) {
        autoFunction.forEach((string) => {
          this.course.code.splice(indexBeforePush, 0, string)
          indexBeforePush += 1
        })
        actionFunction.forEach((string) => {
          this.course.code.splice(indexBeforePush, 0, string)
          indexBeforePush += 1
        })
        /* eslint-disable-next-line standard/computed-property-even-spacing */
        this.course.code[this.course.code.length - 1] = this.course.code[
          this.course.code.length - 1
        ].slice(0, -1)
        this.course.code[this.course.code.length - 1] += ','
        this.course.code.push(`    ${newFunctionsString}}`)
      } else {
        autoFunction.forEach((s) => this.course.code.push(s))
        actionFunction.forEach((s) => this.course.code.push(s))
        this.course.code.push(`module.exports = { ${newFunctionsString}}`)
      }
    },
    addMistake(api, message) {
      this.mistakes.push({
        stage: this.selectedStage.name,
        step: this.currentStep + 1,
        role: this.selectedRole,
        mistake: message
      })
      this.panels[this.selectedPanel].restore(
        api.panel.statesBefore[this.currentStep],
      )
      this.$refs.panel.initPanel()
      this.countMistakes += 1
      this.pushToasts({
        title: 'Ошибка',
        error: true,
        message: `Было выполнено неправильное действие.<br>
          Ошибка: <strong>${message}</strong><br>
          Допущено ошибок: <strong>${this.countMistakes}.</strong>`,
        time: 3
      })
    },
    getMarks(mistakes, marksMap) {
      if (mistakes <= marksMap['5']) {
        return 5
      }
      if (mistakes <= marksMap['4']) {
        return 4
      }
      if (mistakes <= marksMap['3']) {
        return 3
      }
      return 2
    },
    showResults() {
      if (this.trainingSettings) {
        this.mark = this.getMarks(
          this.countMistakes,
          this.trainingSettings.marksMap,
        )
        this.sendMessage({
          action: 'finishTraining',
          data: {
            trainingId: this.trainingId,
            role: this.trainingRole,
            mark: this.mark,
            mistakes: this.mistakes
          }
        })
      } else {
        this.mark = this.getMarks(this.countMistakes, this.selectedStage.marks)
      }
      this.$bvModal.show('stageFinishModal')
    },
    onClose() {
      this.$router.push('..')
    },
    goPanelBefore() {
      if (this.selectedPanel === 0) {
        this.setSelectedPanel(this.panels.length - 1)
      } else {
        this.setSelectedPanel(this.selectedPanel - 1)
      }
    },
    goPanelAfter() {
      if (this.selectedPanel === this.panels.length - 1) {
        this.setSelectedPanel(0)
      } else {
        this.setSelectedPanel(this.selectedPanel + 1)
      }
    },
    showInstruction() {
      this.$bvModal.show('instructionModal')
    },
    showHint() {
      let message = 'Действия не назначены.'
      const step = this.instruction[this.currentStep]
      if (step) {
        if (!step[this.selectedRole].isPassed) {
          message = step[this.selectedRole].message
        } else {
          message = 'Вы выполнили все свои действия на текущем шаге. Ожидайте выполнения действий другими ролями.'
        }
      } else {
        message = 'На текущем шаге действий для выбранной роли не задано.'
      }
      this.pushToasts({
        title: 'Подсказка',
        message,
        time: 7
      })
    },
    onColumnResized() {
      this.gridApi.resetRowHeights()
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.gridApi.sizeColumnsToFit()
    },
    onGridSizeChanged() {
      this.gridApi.sizeColumnsToFit()
    },
    onRowDataChanged() {
      if (this.gridApi) {
        this.gridApi.sizeColumnsToFit()
      }
    }
  }
}
</script>

<style>
.panelDiv {
  width: 704px;
}

.panelDiv__panel-buttons_div {
  height: 50px;
}
.panelDiv__panel-buttons,
.panelDiv__label-buttons {
  font-size: 12px;
}

.panelDiv__panel {
  clear: both;
  border: 1px solid black;
  height: 55px;
}
.instrumentsDiv__instruments {
  border: solid 1px black;
  height: 55px;
}
.ag-grid-for-instruction-training .ag-row .ag-cell {
  font-size: 15px;
  justify-content: left;
  display: inline-block;
  vertical-align: top;
  text-align: left;
  white-space: normal;
  line-height: 1.4em !important;
}

.ag-grid-for-instruction-training {
  height: 350px;
  border-bottom: 1px solid #017ac3;
  margin-left: 20px;
}
.instruction-table-header {
  background-color: #017ac3;
  color: white;
}
.instruction-table-header:hover {
  background-color: #017ac3 !important;
  color: white;
}
</style>
